import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import ConfigContext from '../../../contexts/ConfigContext';
import { getTruckBadgeMap } from '../../../modules/truckUtils';

import styles from './Truck.module.postcss';

function TruckHighlights({ truck }) {
  const config = useContext(ConfigContext);
  const badgeMap = getTruckBadgeMap(truck, config);
  const badgeList = badgeMap.map(({ imageName, description }) => (
    <div key={`${truck.id}-${imageName}`}>
      <img src={`/static/images/badges/${imageName}.webp`} alt={description} loading='lazy' />
      <p>{description}</p>
    </div>
  ));

  return (
    <div className={styles.TruckHighlights}>
      <h3 className='u-phosphate'>
        <SVG src='/static/images/icons/bluefire.svg' height='30'/>
        <span>Highlights</span>
      </h3>
      <div className={styles.TruckHighlights_badges + ' u-textCenter'}>
        {badgeList}
      </div>
    </div>
  );
}

TruckHighlights.propTypes = {
  truck: PropTypes.object.isRequired,
};

export default TruckHighlights;
